// src/graphql/fragments/index.js
// GraphQL fragments for reuse across queries

export const tenderFields = `
    id
    externalId
    title
    description
    type
    rootCpv
    estimatedValue
    currency
    procedureType
    isFramework
    hasOptions
    publicationDate
    location {
        address
        city
        state
        postalCode
        country
        nutsCode
        latitude
        longitude
    }
    url
    deadline
    startDate
    endDate
    status
    crawlStatus
    crawlError
    lastCrawled
    lastUpdated
    createdAt
    latitude
    longitude
    processingState
    stateChangedAt
    indexedAt
`;

export const assessmentFields = `
    id
    tenderId
    companyId
    overallScore
    criterionScores {
        id
        label
        score
    }
    matchReasons {
        id
        label
        strength
        evidence {
            passageId
            tenderId
            documentId
            documentTitle
            snippet
            charStart
            charEnd
            polarity
            scores {
                dense
                sparse
                rerank
                fused
            }
        }
    }
    pipeline
    processingTimeMs
    assessedAt
    updatedAt
    error
    isOutdated
    fingerprintHash
`;

export const documentFields = `
    id
    title
    fileType
    fileSize
    isIndexed
`;

export const userFields = `
    id
    email
    firstName
    lastName
    companyId
    role
    jobTitle
    avatar
    active
    lastLogin
    isCompanyRepresentative
    createdAt
    updatedAt
`;

export const companyFields = `
    id
    name
    size
    industry
    location {
        address
        city
        state
        postalCode
        country
        nutsCode
        latitude
        longitude
    }
    website
    description
    active
    createdAt
    updatedAt
`;

export const subscriptionFields = `
    id
    companyId
    tier
    status
    billingCycle
    price
    priceWithDiscount
    startDate
    endDate
    trialEnd
    canceledAt
    lastBillingDate
    nextBillingDate
    paymentMethod
    createdAt
    updatedAt
`;

export const jobFields = `
    id
    type
    status
    tenderId
    parameters
    result
    error
    startedAt
    completedAt
    cronSchedule
    enabled
    isScheduled
    lastScheduledRun
    nextScheduledRun
    createdAt
    updatedAt
`;

export const fingerprintFields = `
    id
    companyId
    profileName
    isActive
    description
    primaryServices
    technicalSkills
    domainExpertise
    certifications
    yearsInBusiness
    teamSize
    governmentExperience
    enterpriseExperience
    startupExperience
    growthAreas
    avoidAreas
    competitiveAdvantages
    languages
    cpvCodes
    nutsCodes
    contractForms
    submissionElectronicOnly
    awardPriceOnlyOk
    awardPriceWeightMax
    budgetMin
    budgetMax
    timelineStartBy
    timelineDurationMonthsMax
    subcontractingPolicy
    deliveryModels
    referenceTopics
    referenceRegions
    referenceMinCount
    referenceMinValueEur
    teamMinSize
    teamHasProjectManager
    criteria {
        id
        label
        must
        mustNot
        hints
        weight
    }
    synonyms {
        term
        synonyms
    }
    fieldBoostTitle
    fieldBoostBody
    productLines
    productKeywords
    productSpecDocumentIds
    createdAt
    updatedAt
`;
